/*
 * Copyright (c) 2021.  Blacksheepz media B.V.
 * https://www.blacksheepz-media.com
 * Ramon van Ophuizen
 */

import React from 'react';
import { withTranslation } from 'react-i18next';
import CartComponent from "../components/Product/CartComponent";

function Cart(props) {

    return (
        <CartComponent {...props} shoppingcart={true}  />
    );

}

export default React.memo(withTranslation(['message', 'shoppingcart'])(Cart));
